import { CSSProperties, ReactNode, useEffect, useRef, useState } from 'react'
import { Stack } from '@common/ui'
import classes from './ScrollFadeContainer.module.css'

type ScrollFadeContainerProps = {
  children: ReactNode
  style?: CSSProperties
}

const ScrollFadeContainer = ({ children, style }: ScrollFadeContainerProps) => {
  const scrollRef = useRef<HTMLDivElement>(null)
  const [overflows, setOverflows] = useState(false)

  useEffect(() => {
    const el = scrollRef.current
    if (!el) return
    const check = () => setOverflows(el.scrollHeight > el.clientHeight)
    check()
    const observer = new ResizeObserver(check)
    observer.observe(el)
    return () => observer.disconnect()
  }, [children])

  return (
    <div className={classes.root} data-overflows={overflows ? 'true' : 'false'} style={style}>
      <Stack ref={scrollRef} gap="md" p="sm" pt="xs" style={{ overflow: 'auto' }}>
        {children}
      </Stack>
    </div>
  )
}

export default ScrollFadeContainer
